module.exports = __webpack_public_path__ + "static/media/1_Pluma-min.c733d884.jpg";